<template>
    <div class="">
        <form
            autocomplete="off"
            method="post"
            data-vv-scope="form"
            @keyup.enter="
                () => {
                    return false;
                }
            "
            @submit.prevent="
                () => {
                    return false;
                }
            "
        >
            <div class="row">
                <div class="col-md-6 col-lg-3 col-xl-2">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            type="text"
                            id="input-code"
                            name="code"
                            v-model.trim="form.code"
                            v-validate="''"
                            :inputClasses="[{ 'is-invalid': fnHasError('code') }]"
                            :error="fnFirstError('code')"
                        >
                            {{ $t(`${modelTranslateID}.code`) }}
                        </MaterialInput>
                    </div>
                </div>
                <div class="col-md-6 col-md">
                    <div class="form-group">
                        <MaterialInput
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            type="text"
                            id="input-name"
                            name="name"
                            v-model.trim="form.name"
                            v-validate="''"
                            :inputClasses="[{ 'is-invalid': fnHasError('name') }]"
                            :error="fnFirstError('name')"
                        >
                            {{ $t(`${modelTranslateID}.name`) }}
                        </MaterialInput>
                    </div>
                </div>
                <div class="col-12 col-md-auto">
                    <div class="form-group">
                        <MaterialCheckbox
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            false-value="0"
                            true-value="1"
                            class="city-form-group"
                            id="input-maintenance"
                            name="maintenance"
                            v-model.trim="form.maintenance"
                            v-validate="''"
                            :inputClasses="[{ 'is-invalid': fnHasError('maintenance') }]"
                            :error="fnFirstError('maintenance')"
                        >
                            <strong> {{ $t(`${modelTranslateID}.maintenance`) }}</strong>
                        </MaterialCheckbox>
                    </div>
                </div>
                <div class="col-12 col-md-auto">
                    <div class="form-group">
                        <MaterialCheckbox
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group"
                            id="input-status"
                            name="status"
                            v-model.trim="form.status"
                            v-validate="''"
                            :inputClasses="[{ 'is-invalid': fnHasError('status') }]"
                            :error="fnFirstError('status')"
                        >
                            <strong> {{ $t(`${modelTranslateID}.status`) }}</strong>
                        </MaterialCheckbox>
                    </div>
                </div>
                <div class="col-12 col-sm-12">
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-8 col-xl-9">
                            <div class="form-group">
                                <label class="city-label">{{ $t(`${modelTranslateID}.description`) }}</label>
                                <div
                                    class="city-form-group"
                                    :class="{ 'is-invalid': fnHasError('description') }"
                                >
                                    <ckeditor
                                        :readonly="readonlyForm"
                                        :disabled="readonlyForm"
                                        name="description"
                                        v-model="form.description"
                                        :editor="cKEditor.editor"
                                        :config="cKEditor.editorConfig"
                                        v-validate="''"
                                    />
                                    <small
                                        v-if="fnFirstError('description')"
                                        class="d-block invalid-feedback"
                                        >{{ fnFirstError("description") }}</small
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4  col-xl-3 city-form-group upload-image">
                            <UploadMultipleImage
                                :disabled="readonlyForm"
                                v-model="form.images"
                                :maxImage="maxImages"
                                :enableMainImage="enableMainImage"
                                :imageSize="imageSize"
                                :imagesPerRow="imagesPerRow"
                                :direction="imageDirection"
                                :noSpaceBetween="true"
                                :heightAuto="false"
                                pathProperty="url"
                                filenameProperty="filename"
                                :extraNewProperties="newImageProperties"
                                imageClass="background-contain"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="form-group">
                        <MaterialSelect
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-admin1_code"
                            name="admin1_code"
                            v-model="form.admin1_code"
                            :initialData="form.admin1"
                            label="name"
                            :options="admin1_codes"
                            :reduce="option => option.code"
                            v-validate="''"
                            @selected="onSelectedAdmin1_code"
                            :inputClasses="[{ 'is-invalid': fnHasError('admin1_code') }]"
                            :error="fnFirstError('admin1_code')"
                        >
                            {{ $t(`${modelTranslateID}.admin1_code`) }}
                        </MaterialSelect>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="form-group">
                        <MaterialSelect
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-admin2_code"
                            name="admin2_code"
                            label="name"
                            v-model="form.admin2_code"
                            :initialData="form.admin2"
                            :options="admin2_codes"
                            :reduce="option => option.code"
                            @selected="onSelectedAdmin2_code"
                            v-validate="''"
                            :inputClasses="[{ 'is-invalid': fnHasError('admin2_code') }]"
                            :error="fnFirstError('admin2_code')"
                        >
                            {{ $t(`${modelTranslateID}.admin2_code`) }}
                        </MaterialSelect>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                        <MaterialSelect
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-admin3_code"
                            name="admin3_code"
                            label="name"
                            v-model="form.admin3_code"
                            :initialData="form.admin3"
                            :options="admin3_codes"
                            :reduce="option => option.code"
                            @selected="onSelectedAdmin3_code"
                            v-validate="''"
                            :inputClasses="[{ 'is-invalid': fnHasError('admin3_code') }]"
                            :error="fnFirstError('admin3_code')"
                        >
                            {{ $t(`${modelTranslateID}.admin3_code`) }}
                        </MaterialSelect>
                    </div>
                </div>
                <!-- <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                        <MaterialSelect
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-admin4_code"
                            name="admin4_code"
                            label="name"
                            v-model="form.admin4_code"
                            :initialData="form.admin4"
                            :options="admin4_codes"
                            :reduce="option => option.code"
                            v-validate="''"
                            :inputClasses="[{ 'is-invalid': fnHasError('admin4_code') }]"
                            :error="fnFirstError('admin4_code')"
                        >
                            {{ $t(`${modelTranslateID}.admin4_code`) }}
                        </MaterialSelect>
                    </div>
                </div> -->
                <div class="col-12 col-lg-3">
                    <div class="form-group">
                        <MaterialTextarea
                            :rows="5"
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            id="input-working_hours"
                            name="working_hours"
                            v-model.trim="form.working_hours"
                            v-validate="''"
                            :inputClasses="['h-100', { 'is-invalid': fnHasError('working_hours') }]"
                            :error="fnFirstError('working_hours')"
                        >
                            {{ $t(`${modelTranslateID}.working_hours`) }}
                        </MaterialTextarea>
                    </div>
                </div>
                <div class="col-12 col-lg-9 row p-0 m-0">
                    <div class="col-md-6 col-lg-3">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyForm"
                                :disabled="readonlyForm"
                                class="city-form-group city-bg"
                                type="text"
                                id="input-phone"
                                name="phone"
                                v-model.trim="form.phone"
                                v-validate="''"
                                :inputClasses="[{ 'is-invalid': fnHasError('phone') }]"
                                :error="fnFirstError('phone')"
                            >
                                {{ $t(`${modelTranslateID}.phone`) }}
                            </MaterialInput>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-5">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyForm"
                                :disabled="readonlyForm"
                                class="city-form-group city-bg"
                                type="text"
                                id="input-email"
                                name="email"
                                v-model.trim="form.email"
                                v-validate="''"
                                :inputClasses="[{ 'is-invalid': fnHasError('email') }]"
                                :error="fnFirstError('email')"
                            >
                                {{ $t(`${modelTranslateID}.email`) }}
                            </MaterialInput>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="readonlyForm"
                                :disabled="readonlyForm"
                                class="city-form-group city-bg"
                                type="text"
                                id="input-web_site"
                                name="web_site"
                                v-model.trim="form.web_site"
                                v-validate="''"
                                :inputClasses="[{ 'is-invalid': fnHasError('web_site') }]"
                                :error="fnFirstError('web_site')"
                            >
                                {{ $t(`${modelTranslateID}.web_site`) }}
                            </MaterialInput>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-6 col-xl-8">
                        <div class="form-group">
                            <MaterialSelect
                                :readonly="readonlyForm"
                                :disabled="readonlyForm"
                                class="city-form-group city-bg"
                                id="input-street"
                                name="street"
                                label="name"
                                v-model="form.street_id"
                                :initialData="form.street"
                                v-validate="''"
                                :inputClasses="[{ 'is-invalid': fnHasError('street') }]"
                                :error="fnFirstError('street')"
                            >
                                {{ $t(`${modelTranslateID}.street`) }}
                            </MaterialSelect>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-3 col-xl-2">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="true"
                                :disabled="true"
                                class="city-form-group city-bg"
                                type="number"
                                id="input-area"
                                name="area"
                                :step="2"
                                v-model.trim="form.area"
                                v-validate="''"
                                :inputClasses="[{ 'is-invalid': fnHasError('area') }]"
                                :error="fnFirstError('area')"
                            >
                                {{ $t(`${modelTranslateID}.area`) }}
                            </MaterialInput>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-3 col-xl-2">
                        <div class="form-group">
                            <MaterialInput
                                :readonly="true"
                                :disabled="true"
                                class="city-form-group city-bg"
                                type="number"
                                id="input-perimeter"
                                name="perimeter"
                                :step="2"
                                v-model.trim="form.perimeter"
                                v-validate="''"
                                :inputClasses="[{ 'is-invalid': fnHasError('perimeter') }]"
                                :error="fnFirstError('perimeter')"
                            >
                                {{ $t(`${modelTranslateID}.perimeter`) }}
                            </MaterialInput>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <MaterialTextarea
                            :rows="4"
                            :readonly="readonlyForm"
                            :disabled="readonlyForm"
                            class="city-form-group city-bg"
                            type="text"
                            id="input-obs"
                            name="obs"
                            v-model.trim="form.obs"
                            v-validate="''"
                            :inputClasses="[{ 'is-invalid': fnHasError('obs') }]"
                            :error="fnFirstError('obs')"
                        >
                            {{ $t(`${modelTranslateID}.obs`) }}
                        </MaterialTextarea>
                    </div>
                </div>
                <div class="col-12 col-sm-12">
                    <CemeteryFiles
                        v-model="form.files"
                        :panelCfg="panelCfg"
                        :vScope="vScope"
                        :readonlyForm="readonlyForm"
                        :baseTranslateID="baseTranslateID"
                    />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import FormMixin from "./mixins/FormMixin";
import CkEditorConfigMixin from "@/app/shared/mixins/ckeditor/BaseCkEditorConfigMixin";
export default {
    mixins: [FormMixin, CkEditorConfigMixin],
    props: {
        admin1_codes: {
            type: Array,
            default: () => []
        }
    },
    data() {
        let idPanel = "cemetery";
        return {
            idPanel: idPanel
        };
    },
    components: {
        UploadMultipleImage: () => import(/* webpackChunkName: "upload-multiple-image" */ "@/components/form/UploadMultipleImage"),
        CemeteryFiles: () => import(/* webpackChunkName: "cemeteries-deedowner-files" */ "./elements/CemeteryFiles")
    },
    computed: {
        admin2_codes() {
            const selected = this.admin1_codes.find(({ code }) => code === this.form?.admin1_code);
            return selected?.admin2_codes || [];
        },
        admin3_codes() {
            const selected = this.admin2_codes.find(({ code }) => code === this.form?.admin2_code);
            return selected?.admin3_codes || [];
        },
        admin4_codes() {
            const selected = this.admin3_codes.find(({ code }) => code === this.form?.admin3_code);
            return selected?.admin4_codes || [];
        },
        imagesCfg() {
            return this.panelCfg?.panel?.images ?? {};
        },
        imagesNewCfg() {
            return this.imagesCfg?.new ?? {};
        },
        newImageProperties() {
            return this.imagesNewCfg?.properties ?? {};
        },
        enableMainImage() {
            return this.imagesCfg.main_image ?? false;
        },
        imageSize() {
            return "small";
        },
        maxImages() {
            return this.imagesCfg.max ?? 1;
        },
        imagesPerRow() {
            return this.imagesCfg.per_row ?? 1;
        },
        imageDirection() {
            return this.imagesCfg.direction ?? "vertical";
        }
    },
    methods: {
        onSelectedAdmin1_code() {
            this.setAdmin_codes(1);
        },
        onSelectedAdmin2_code() {
            this.setAdmin_codes(2);
        },

        onSelectedAdmin3_code() {
            this.setAdmin_codes(3);
        },
        setAdmin_codes(level) {
            switch (level) {
                case 1:
                    this.form.admin2_code = this.admin2_codes.length === 1 ? this.admin2_codes[0] : null;

                case 2:
                    this.form.admin3_code = this.admin3_codes.length === 1 ? this.admin3_codes[0] : null;

                case 3:
                    this.form.admin4_code = this.admin4_codes.length === 1 ? this.admin4_codes[0] : null;
                    break;
                default:
                    break;
            }
        }
    },
    watch: {
        admin1_codes(newVal) {
            // if(!this.form.admin1_code && this.admin1_codes.length === 1) this.form.admin1_code=this.admin1_codes[0] ;
            this.form.admin1_code ||= this.admin1_codes.length === 1 ? this.admin1_codes[0] : null;
            this.form.admin2_code ||= this.admin2_codes.length === 1 ? this.admin2_codes[0] : null;
            this.form.admin3_code ||= this.admin3_codes.length === 1 ? this.admin3_codes[0] : null;
            this.form.admin4_code ||= this.admin4_codes.length === 1 ? this.admin4_codes[0] : null;
        }
    }
};
</script>

<style lang="scss" scoped>

</style>
